import DataTable from "react-data-table-component"
import ConstantesTabla from "../../../utils/ConstantesTabla"
import { Iconos } from "../../../utils/Iconos"

const DataTablePaginacionExterna = (object) => {

    const handleCambioPagina = (tipo) => {
        if (tipo === "sig" && !object?.data?.last) {
            object.setCurrentPage((prevPage) => prevPage + 1);
        } else if (tipo === "ant" && !object?.data?.first) {
            object.setCurrentPage((prevPage) => prevPage - 1);
        }
    };

    const handleCambioTamanoTabla = (e) => {
        setTimeout(() => {
            object.setPageSize(parseInt(e.target.value));
        }, 700);
    };

    return (<>
        <div className="">
            <DataTable
                className="table-reponsive"
                columns={object.columnas}
                data={object?.data?.content}
                pagination={false}
                paginationComponentOptions={
                    ConstantesTabla.paginacionOpt
                }
                noDataComponent={
                    <span></span>
                }
                customStyles={ConstantesTabla.customStyles2}

            />
        </div>

        <div className="div row my-3 paginacion">
            <div className="iconoSiguientePagina col-4 d-flex justify-content-center">
                <div className="iconoX" role="button" onClick={() => handleCambioPagina("ant")}>
                    {Iconos.iconoMoverIzquierda}
                </div>
            </div>
            <div className="numsPaginas col-4">
                <div className="paginas text-center">
                    Pagina {object.currentPage + 1} de {object.totalPages}
                </div>
                <div className="elementos text-center">
                    Total Elementos : {object?.data?.totalElements}
                </div>
                <div className="row d-flex justify-content-center align-items-center">
                    <span className="col-lg-3 text-dark text-md-center text-lg-left">Tamaño:</span>

                    <div className="col-md-6 col-lg-3"><input type="number" max={object?.data?.totalElements} name="tamanoPag" id="tamanoPag" className="form-control" onInput={handleCambioTamanoTabla} /></div>
                </div>
            </div>
            <div className="iconoSiguientePagina col-4 d-flex justify-content-center">
                <div className="iconoX" role="button" onClick={() => handleCambioPagina("sig")}>
                    {Iconos.iconoMoverDerecha}
                </div>
            </div>
        </div>
    </>)
}

export default DataTablePaginacionExterna